import axios from '../utils/axios';

export default function getBulkJobUpload(adminId,params) {
    return (
        axios.get('/admin/' + adminId + '/bulk-job-upload',{ params })
        .then(res => {
            return res.data
        })
        .catch(err => {
            return err;
        })
    )
}
